export default {
    dataPicker: {
        feedback: 'The field is required to fill in!',
    },

    excel: {
        button: 'Uploading a list to Excel',
    },

    multiselect: {
        selectLabel: 'Click to select',
        selectedLabel: 'Selected',
        deselectLabel: 'Click to withdraw',
        noOptions: 'The list is empty',
        noResult: 'Information not found',
        invalid: 'The field is required to fill in!',
    },

    selectEditField: {
        formSelectError: 'Please indicate the reason for the postponement',
    },

    customFrom: '{firstParam} from {secondParam}',

    reportHandler: {
        heading: 'Загрузка файла',
        description: 'Описание',
        download: 'Скачать',
        reset: 'Сбросить',
        info: 'Дополнительная информация',
        handled: 'Файл успешно обработан, нажмите кнопку «Скачать»',
        fileNotSelected: 'Файл не выбран',
        chooseFile: 'Выберите файл',
        error: 'Что-то пошло не так...',
        kuper: {
            header: 'Отчет по заказам Купер-витрина',
            description: 'Формирует отчет по заказам Купер-витрина, включая дату и время получения вебхука order.recieved',
            info: 'Скачать шаблон {link} для заполнения',
            template: '.xlsx-файла',
            error: 'Не удалось получить имя файл',
        },
    },
};